var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      pad: "0",
      title: _vm.$t("label_essweb_admin_RosterFormRecord_list_title"),
      filterable: "",
    },
    on: {
      activated: _vm.activated,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                showSelect: _vm.showSelect,
                "filter-page-data": _vm.filterPageData,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.number",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: item.roster_form_record_swift_number,
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(item.roster_form_record_swift_number) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.title",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "text--primary table-title",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.roster_form_record_title
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.roster_form_record_title
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "table-subtitle text--secondary",
                          attrs: {
                            title: _vm.$getCommonLangValue(
                              item.roster_form_record_description
                            ),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.roster_form_record_description
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.startTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(
                              item.roster_utc_start_date,
                              "YYYY/MM/DD"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.endTime",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(
                              item.roster_utc_end_date,
                              "YYYY/MM/DD"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.manage",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        [
                          _vm._l(
                            item.ess_att_roster_form_records_detail_manager,
                            function (it, index) {
                              return [
                                index < 3
                                  ? _c("StaffAvatar", {
                                      key: index,
                                      attrs: {
                                        size: 36,
                                        contentClass: "mr-n3",
                                        src: it.mrbase_sys_staffs.staff_avatar,
                                        staff_name:
                                          it.mrbase_sys_staffs.preferred_name,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            }
                          ),
                          item.ess_att_roster_form_records_detail_manager
                            .length > 3
                            ? _c("span", { staticClass: "pl-4" }, [
                                _vm._v(
                                  "..." +
                                    _vm._s(
                                      item
                                        .ess_att_roster_form_records_detail_manager
                                        .length - 3
                                    )
                                ),
                              ])
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "item.status",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-container",
                        { staticClass: "d-flex align-center pa-0 ma-0" },
                        [
                          Number(item.is_locked) == 1
                            ? _c(
                                "v-btn",
                                {
                                  class:
                                    item.is_locked == 1
                                      ? "text--primary"
                                      : "text--secondary",
                                  attrs: { icon: "", small: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons-round md-18",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.is_locked == 1
                                            ? "lock"
                                            : "lock_open"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("StatusChip", {
                            attrs: {
                              icon: "",
                              slideColor: item.approval_tint_color,
                              bgColor: item.approval_bg_color,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "status",
                                  fn: function () {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.status_detail
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          editBtn:
                            item["status_uuid"] === "Draft" &&
                            _vm.hasBtn("edit-admin-roster-form-record"),
                          delBtn: _vm.hasBtn("delete-admin-roster-form-record"),
                          viewBtn: _vm.hasBtn("view-admin-roster-form-record"),
                          title: _vm.$t(
                            "label_essweb_admin_RosterFormRecord_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toEdit,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }